import axios from 'axios';
import { getCurrentApiHost, API_NAMESPACE, API_VERSION } from 'config/environment';
import { ApiKey } from './api-key';
import { logger } from './logger';
let _apiKey;
const savePreviewApiKey = async (projectId)=>{
    if ((_apiKey === null || _apiKey === void 0 ? void 0 : _apiKey[0]) === projectId) {
        return;
    }
    try {
        const { data: { apiKey } } = await axios.get(`${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/projects/${projectId}/customer-access`, {
            headers: ApiKey.header()
        });
        _apiKey = [
            projectId,
            apiKey
        ];
    } catch (error) {
        logger.error('unable to get preview api key', {
            error
        });
        throw error;
    }
};
const saveLiveCpApiKey = async (projectId)=>{
    if ((_apiKey === null || _apiKey === void 0 ? void 0 : _apiKey[0]) === projectId) {
        return;
    }
    try {
        var _ref;
        var _apiKey_data;
        const apiKey = await axios.get(`${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}/customer-portal-builder/bot-api-key/project/${projectId}`, {
            headers: ApiKey.header()
        });
        _apiKey = [
            projectId,
            (_ref = apiKey === null || apiKey === void 0 ? void 0 : (_apiKey_data = apiKey.data) === null || _apiKey_data === void 0 ? void 0 : _apiKey_data.apiKey) !== null && _ref !== void 0 ? _ref : ''
        ];
    } catch (error) {
        logger.error('unable to get live cp api key', {
            error
        });
        throw error;
    }
};
const isPreviewMode = async ()=>{
    var _pathname_match;
    if (_apiKey != null) {
        return [
            true,
            _apiKey[0]
        ];
    }
    const { pathname } = window.location;
    const { search } = window.location;
    const [, _projectId] = (_pathname_match = pathname.match(/\/projects\/(.*)\//)) !== null && _pathname_match !== void 0 ? _pathname_match : [];
    const hasProjectId = typeof _projectId === 'string' && _projectId !== '';
    const projectId = parseInt(_projectId, 10);
    const customerPreview = /customer-preview=true/.test(search) && hasProjectId;
    const isLiveCustomerPortal = /live-customer-portal-preview/.test(pathname);
    if (isLiveCustomerPortal) {
        var _ref;
        const match = pathname.match(/live-customer-portal-preview\/(\d+)/);
        const liveCpProjectId = parseInt((_ref = match === null || match === void 0 ? void 0 : match[1]) !== null && _ref !== void 0 ? _ref : '', 10);
        await saveLiveCpApiKey(liveCpProjectId);
        return [
            false
        ];
    }
    if (!customerPreview) {
        _apiKey = null;
        return [
            false
        ];
    }
    try {
        await savePreviewApiKey(projectId);
        return [
            true,
            projectId
        ];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        return [
            false
        ];
    }
};
const header = ()=>// eslint-disable-next-line @typescript-eslint/naming-convention
    _apiKey == null ? {} : {
        'api-key': _apiKey[1]
    };
export const CustomerPreview = {
    header,
    isPreviewMode
};
